import React from 'react'
import {Paper, Table, TableBody, TableCell, TableRow, Typography} from '@mui/material';
import PropTypes from "prop-types";
import {ScreenshotRow} from "./Row";

const ScreenshotsTable = ({screenshots}) => {

    return (
        <div className="search-messages-table">
            <Paper>
                <Table>
                    <thead>
                    <TableRow>
                        <TableCell sx={{width: "35%"}}>
                            <Typography>Message</Typography>
                        </TableCell>
                        <TableCell sx={{width: "11%"}}>
                            <Typography>Name</Typography>
                        </TableCell>
                        <TableCell>
                            <Typography>Email</Typography>
                        </TableCell>
                        <TableCell>
                            <Typography>Reviewer</Typography>
                        </TableCell>
                        <TableCell sx={{width: "14%"}}>
                            <Typography>Date</Typography>
                        </TableCell>
                        <TableCell></TableCell>
                    </TableRow>

                    </thead>
                    <TableBody>
                        {screenshots && screenshots.length === 0  &&
                        <TableRow>
                            <TableCell colSpan={4}>There are no screenshots available</TableCell>
                        </TableRow>}

                        {screenshots && screenshots.length > 0 && screenshots.map(screenshot => {
                            return (
                                <ScreenshotRow
                                    key={screenshot.id}
                                    screenshot={screenshot}
                                />
                            )
                        })}
                    </TableBody>
                </Table>
            </Paper>
        </div>
    )
};
ScreenshotsTable.propStyles = {
    classes: PropTypes.object.isRequired,
}

export {ScreenshotsTable}